<template>
  <div>
    <PageHead title="草稿箱"></PageHead>
    <div class="drafts oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id)">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },
  {
    title: '工程项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    ellipsis: true
  },
  {
    title: '对方结算单位',
    dataIndex: 'otherPartyCompany',
    key: 'otherPartyCompany'
  },

  {
    title: '合同总价款(元)',
    dataIndex: 'totalPrice',
    key: 'totalPrice'
  },
  {
    title: '申请用款金额(元)',
    dataIndex: 'applyFee',
    key: 'applyFee'
  },
  {
    title: '累计支付进度（%）',
    dataIndex: 'paymentProgress',
    key: 'paymentProgress',
    ellipsis: true
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' }
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { MoneyProjectDraftlist, delMoneyProject } from './api/api'
export default {
  data() {
    return {
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  created() {
    // this.load()
  },
  methods: {
    load() {
      this.loading = true
      let params = {
        page: this.page,
        size: this.size
      }
      MoneyProjectDraftlist(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delMoneyProject({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id) {
      if (id) {
        this.$router.push({
          path: '/ProjectFundApplicationDetial',
          query: {
            id
          }
        })
      } else {
        this.$router.push('/ProjectFundApplicationDetial')
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ProjectFundApplication/drafts.vue